import React, { useState, useEffect } from "react"; // Agregado useState, useEffect
import { Box, Typography, Button, useTheme, styled } from "@mui/material";
import { isMobile } from "react-device-detect";
import landingPlataforma from "../../../assets/images/plataforma.webp";
import demoimagen from "../../../assets/images/demo.webp";



// Removido import de landingPlataforma - el archivo está en public/
import AnimatedNotifications from "./KinePortada";

const ActionButton = styled(Button)(() => ({
  backgroundColor: "#4669E8",
  color: "white",
  padding: "8px 24px",
  borderRadius: "8px",
  textTransform: "none",
  fontFamily: "Quicksand-Regular",
  fontSize: isMobile ? "14px" : "16px",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#2952CC",
  },
}));

const KinesiologoIntro = ({ scrollToPricing }) => {
  const theme = useTheme();
  const [showImage, setShowImage] = useState(false); // Estado para controlar animación

  // Activar animación al montar
  useEffect(() => {
    const timer = setTimeout(() => setShowImage(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handlePricingClick = () => {
    // NUEVO: Tracking de intención en Hero
    if (window.fbq) {
      window.fbq('trackCustom', 'inicioregistro');
    }

    if (scrollToPricing) {
      scrollToPricing();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        mb: { xs: 10, md: 15 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Contenido de texto centrado */}
      <Box
        sx={{
          textAlign: { xs: "center", md: "center" },
          maxWidth: "900px",
          width: "100%",
          mb: { xs: 4, md: 6 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-SemiBold",
            fontSize: { xs: "28px", md: "52px" },
            color: "#141414",
            mt: { xs: 5, md: 10 },
            mb: { xs: 3, md: 4 },
            lineHeight: 1.25,
          }}
        >
          Plataforma para profesionales de la salud independientes
        </Typography>

        <Typography
          sx={{
            mb: { xs: 3, md: 4 },
            fontFamily: "Poppins-Regular",
            fontSize: { xs: "14px", md: "20px" },
            color: "#141414",
            lineHeight: 1.6,
          }}
        >
          Gestionamos tu agenda, cobramos por ti, emitimos tus boletas y enviamos recordatorios a todos tus pacientes.
        </Typography>

        <Box sx={{
          display: "flex",
          gap: theme.spacing(2),
          justifyContent: { xs: "center", md: "center" },
          mb: { xs: 2, md: 4 }
        }}>
          <ActionButton
            variant="contained"
            onClick={handlePricingClick}
          >
            Comenzar gratis
          </ActionButton>
        </Box>
      </Box>

      {/* Imagen de la plataforma centrada */}
      <Box
        sx={{
          mb: { xs: 2, md: 6 },
          width: { xs: "95%", md: "90%" },
          maxWidth: "1100px",
          position: "relative",
          isolation: "isolate",
          mx: "auto",
          opacity: showImage ? 1 : 0, // Fade in
          transform: showImage
            ? { xs: 'translateY(0)', md: 'scale(1)' } // Mobile: Slide Up, Desktop: Scale Up
            : { xs: 'translateY(60px)', md: 'scale(0.85)' },
          transition: 'all 0.8s ease-out', // Transición suave
          // Contenedor glassmorphism
          background: 'rgba(241, 241, 241, 0.4)',
          border: { xs: '0.5px solid rgba(255, 255, 255, 0.9)', md: '1px solid rgba(255, 255, 255, 0.9)' },
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)', // Safari support
          borderRadius: { xs: '18px', md: '26px' },
          padding: { xs: '4px', md: '8px' },
          boxShadow: { xs: '0 2px 10px rgba(0, 0, 0, 0.1)', md: '0 8px 32px rgba(0, 0, 0, 0.15)' },
        }}
      >
        {/* Sombra ovalada azul decorativa detrás de la imagen */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '110%', md: '105%' },
            height: { xs: '85%', md: '80%' },
            background: 'radial-gradient(ellipse, rgba(70, 105, 232, 0.25) 0%, rgba(70, 105, 232, 0.08) 50%, transparent 70%)',
            borderRadius: '50%',
            filter: 'blur(60px)',
            zIndex: -1,
            pointerEvents: 'none',
          }}
        />

        <img
          src={demoimagen}
          style={{
            width: "100%",
            height: "auto",
            objectFit: "contain",
            display: "block",
            borderRadius: "14px",
            zIndex: 2,
          }}
          alt="Plataforma Clinifica"
        />
        <AnimatedNotifications />
      </Box>
    </Box>
  );
};

export default KinesiologoIntro;
